import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement, useEffect, useState } from "react";
import { PropertyLine } from "./propertyLine";
import { SyncedSliderPropertyLine } from "./syncedSliderPropertyLine";
/**
 * Runtime-neutral controlled color editor with RGB or RGBA sliders and an injected picker.
 * @param props The controlled color, runtime adapter, and property-line presentation.
 * @returns The color property line.
 */
export const ControlledColorPropertyLine = (props) => {
    const { adapter, value, onChange, propertyLineRef } = props;
    const [currentValue, setCurrentValue] = useState(value);
    useEffect(() => {
        setCurrentValue(value);
    }, [value]);
    const handleChange = (newValue) => {
        setCurrentValue(newValue);
        onChange(newValue);
    };
    const onSliderChange = (componentValue, component) => {
        const color = adapter.getColor(currentValue);
        handleChange(adapter.createColor({
            ...color,
            [component]: component === "a" ? componentValue : componentValue / 255,
        }, currentValue));
    };
    const color = adapter.getColor(currentValue);
    return (_jsx(PropertyLine, { ref: propertyLineRef, ...props, expandedContent: _jsx(ColorSliders, { color: color, onSliderChange: onSliderChange }), children: createElement(adapter.picker, {
            value: currentValue,
            onChange: handleChange,
            isLinearMode: props.isLinearMode,
            disabled: props.disabled,
            className: props.className,
            style: props.style,
            title: props.title,
        }) }));
};
const ColorSliders = (props) => {
    const { color, onSliderChange } = props;
    return (_jsxs(_Fragment, { children: [_jsx(SyncedSliderPropertyLine, { label: "R", value: color.r * 255, min: 0, max: 255, onChange: (value) => onSliderChange(value, "r") }), _jsx(SyncedSliderPropertyLine, { label: "G", value: color.g * 255, min: 0, max: 255, onChange: (value) => onSliderChange(value, "g") }), _jsx(SyncedSliderPropertyLine, { label: "B", value: color.b * 255, min: 0, max: 255, onChange: (value) => onSliderChange(value, "b") }), color.a === undefined ? undefined : (_jsx(SyncedSliderPropertyLine, { label: "A", value: color.a, min: 0, max: 1, step: 0.01, onChange: (value) => onSliderChange(value, "a") }))] }));
};
//# sourceMappingURL=colorPropertyLineCore.js.map